<template>
  <div>
    <label :for="field.id">{{ field.label[currentLanguage] }} <span v-if="field.required" class="required">*</span></label>
    <textarea :name="field.name" :value="value" @change="$emit('input', $event.target.value);$emit('change', '')" :id="field.id" :readonly="field.readonly" :disabled="disabledStatus(field.disabled)" :multiple="field.multi" :required="field.required"></textarea>
    <p class="small" v-if="field.description[currentLanguage]">{{ field.description[currentLanguage] }}</p>
  </div>
</template>

<script>
export default {
  props: ['value', 'field', 'currentLanguage', 'disabledStatus']
}
</script>



// WEBPACK FOOTER //
// src/components/elements/textarea.vue